import { Flex } from '../../components'
import { customTheme } from '../../../../styles/theme'

const Row = ({ children, ...rest }: any) => {
  return (
    <Flex flexWrap="wrap" {...rest} mx={`-${customTheme.gutters}`}>
      {children}
    </Flex>
  )
}

export default Row
